import React, { useEffect, useState } from "react";
import { api, rp } from "@/lib/api";
import { GatewayPanel } from "@/admin/GatewayPanel";
import { FinanceSyncPanel } from "@/admin/FinanceSyncPanel";

export default function Payments() {
  const [rows, setRows] = useState([]);
  const [bookings, setBookings] = useState({});
  useEffect(() => {
    api.get("/payments").then((r) => setRows(r.data));
    api.get("/bookings").then((r) => setBookings(Object.fromEntries(r.data.map((b) => [b.id, b]))));
  }, []);
  const total = rows.reduce((a, p) => a + p.amount, 0);
  return (
    <div data-testid="admin-payments">
      <h1 className="font-display text-3xl tracking-tight">Payments</h1>
      <div className="mt-5"><GatewayPanel /></div>
      <div className="mt-4"><FinanceSyncPanel /></div>
      <div className="mt-4 text-sm text-ink-soft">Total recorded: <span className="font-semibold text-ink" data-testid="payments-total">{rp(total)}</span></div>
      <div className="mt-5 overflow-x-auto bg-white border border-black/10 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-cream-dark text-left text-[11px] uppercase tracking-widest text-ink-soft">
            <tr><th className="p-3">Date</th><th className="p-3">Booking</th><th className="p-3">Customer</th><th className="p-3">Type</th>
              <th className="p-3">Method</th><th className="p-3">Amount</th><th className="p-3">Notes</th></tr>
          </thead>
          <tbody className="divide-y divide-black/5">
            {rows.map((p) => (
              <tr key={p.id}><td className="p-3">{p.payment_date}</td><td className="p-3">{bookings[p.booking_id]?.booking_code || "—"}</td>
                <td className="p-3">{bookings[p.booking_id]?.customer_name || "—"}</td><td className="p-3">{p.payment_type}</td>
                <td className="p-3">{p.payment_method}</td><td className="p-3">{rp(p.amount)}</td><td className="p-3">{p.notes}</td></tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="p-5 text-ink-soft">No payments recorded.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
